"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderOnBehalf = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _context = require("../../context");
var _useTranslations = require("../../hooks/useTranslations");
var _OrderOnBehalfDialog = require("./components/OrderOnBehalfDialog");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OrderOnBehalf = () => {
  const {
    orderOnBehalfData
  } = (0, _context.useTopAreaBanner)();
  const {
    VipAccessData: vipAccessData,
    VipAccessLabels: vipAccessLabels
  } = orderOnBehalfData ?? {};
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useDisclose)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (!vipAccessData || !vipAccessLabels) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OrderContent, {
    "data-testid": getTestId(_constants.ORDER_ON_BEHALF),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.NewUserFilled, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      children: translations.loggedInAs
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Username, {
      onClick: onOpen,
      children: vipAccessData.ConsultantName
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderOnBehalfDialog.OrderOnBehalfDialog, {
      open: open,
      close: onClose,
      vipAccessData: vipAccessData,
      vipAccessLabels: vipAccessLabels
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
  });
};
exports.OrderOnBehalf = OrderOnBehalf;
